
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
const schedule = namespace("schedule");
import moment from "moment";
const profile = namespace("profile");

@Component
export default class AssignmentDetail extends Vue {
  @schedule.State
  public assignmentDetail!: any;

  @schedule.State
  public scheduleId!: string;

  @profile.State
  public profileData!: any;

  isLoaded: boolean = false;
  @Prop() currentEvent: any;

  async mounted() {
    this.getEventDetail();
  }

  getEventDetail() {
    var payload = { 
        username: this.profileData.username, 
        id: this.currentEvent.id
    };  

    this.$store
      .dispatch("schedule/getAssignmentDetail", payload)
      .then(() => {
        this.isLoaded = true;
      })
      .catch((err: any) => {
        if (err) {
          console.log(err); // Handle errors any way you want
        }
      });
  }

  formatDate(date: Date): string {
    return moment(date).format("ddd, MMM D");
  }
  formatTime(t: Date): string {
    return moment(t).format("h:mm a");
  }
}
